import { ELECTRON_API } from "config";
import { useEffect, useState } from "react";

export const useTitleBar = () => {
  const [isTitleBar, setIsTitleBar] = useState(false);
  useEffect(() => {
    if (ELECTRON_API) {
      const { isElectron, isMacOS, getInitialFullScreen, onFullScreenChanged } =
        ELECTRON_API;

      if (!isElectron || !isMacOS) return;

      const checkInitialFullscreen = async () => {
        const isFull = await getInitialFullScreen();
        setIsTitleBar(!isFull);
      };

      checkInitialFullscreen();

      onFullScreenChanged((isFull) => setIsTitleBar(!isFull));
    }
  }, []);

  return { isTitleBar };
};
